var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStudent8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "105mm",
    height: "74mm",
    viewBox: "0 0 105 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m139.273 38.403 3.6-.777c-.723 5.323-1.432 8.527-1.562 9.863h-1.595c.005-2.017-.416-6.066-.443-9.086m2.038 9.28c-.03.316-.044.487-.044.487h-1.553l.002-.487h1.596",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.489 49.372h-1.94v-1.27h1.94v1.27",
    style: {
      fill: "#2bb673",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.59 47.757h1.857v-.268h-1.856v.268",
    style: {
      fill: "#208956",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.356 38.403-3.599-.777c.722 5.323 1.431 8.527 1.56 9.863h1.596c-.005-2.017.417-6.066.443-9.086m-2.038 9.28c.03.316.044.487.044.487h1.553l-.002-.487h-1.596",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.14 49.372h1.94v-1.27h-1.94v1.27",
    style: {
      fill: "#2bb673",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.038 47.757h-1.855v-.268h1.855v.268",
    style: {
      fill: "#208956",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.237 39.73H133.71V37.5h10.527v2.23",
    style: {
      fill: "#2bb673",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.968 13.606s1.11-1.633 3.149-1.127c1.51.374 1.249 1.404 3.354.891 0 0-.807 2.018-2.82.98 0 0 .324.774 1.05.85 0 0-2.862 1.982-4.733-1.135v-.459",
    style: {
      fill: "#f14950",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.395 12.585s.428.964 0 2.411c0 0 .022.153.573.153v-2.677s-.342-.001-.573.113",
    style: {
      fill: "#88b9d1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.536 12.585s.814.86 0 2.411c0 0-.021.153-.568.153v-2.677s.338-.001.568.113",
    style: {
      fill: "#88b9d1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.539 13.606s-1.111-1.633-3.15-1.127c-1.51.374-1.248 1.404-3.355.891 0 0 .806 2.018 2.82.98 0 0-.322.774-1.05.85 0 0 2.863 1.982 4.735-1.135v-.459",
    style: {
      fill: "#f14950",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.11 12.585s-.427.964 0 2.411c0 0-.022.153-.571.153v-2.677s.34-.001.57.113m-1.141 0s-.812.86 0 2.411c0 0 .022.153.57.153v-2.677s-.34-.001-.57.113",
    style: {
      fill: "#88b9d1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.875 16.86c0 2.474-2.269 4.48-5.07 4.48-2.8 0-5.07-2.006-5.07-4.48 0-2.474 2.27-4.479 5.07-4.479 2.801 0 5.07 2.005 5.07 4.478",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.805 20.07c1.13 0 1.589-1.006 1.589-1.912h-3.178c0 .906.506 1.912 1.589 1.912",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.73 15.98c0 .292-.231.53-.514.53a.523.523 0 0 1-.514-.53c0-.293.231-.53.514-.53.283 0 .513.237.513.53",
    style: {
      fill: "#414042",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.485 15.854c0 .12-.095.219-.213.219a.218.218 0 0 1-.214-.22c0-.121.096-.22.214-.22s.213.099.213.22",
    style: {
      fill: "#f1f2f2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.881 15.98c0 .292.229.53.513.53a.523.523 0 0 0 .514-.53.523.523 0 0 0-.514-.53.522.522 0 0 0-.513.53",
    style: {
      fill: "#414042",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.125 15.854c0 .12.096.219.213.219.117 0 .212-.1.212-.22a.216.216 0 0 0-.212-.22.217.217 0 0 0-.213.22",
    style: {
      fill: "#f1f2f2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.38 17.834c0 .361-.352.652-.788.652-.435 0-.788-.291-.788-.652 0-.36.353-.651.788-.651.436 0 .788.292.788.651m4.85 0c0 .361.351.652.786.652.436 0 .789-.291.789-.652 0-.36-.353-.651-.789-.651-.435 0-.787.292-.787.651",
    style: {
      fill: "#fdb5ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.695 17.834a.706.706 0 0 1-.694.717.705.705 0 0 1-.694-.717c0-.394.31-.714.694-.714.382 0 .694.32.694.714m8.221 0c0 .397.31.717.692.717.384 0 .695-.32.695-.717a.705.705 0 0 0-.695-.714.703.703 0 0 0-.692.714m-4.867 2.985v1.822h1.513v-1.822h-1.513",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.5 14.665c-.482 0-.898.173-1.105.424 0 0 .518-.295 1.105-.295.617 0 1.107.295 1.107.295-.208-.251-.623-.424-1.107-.424m-3.391 0c.483 0 .898.173 1.106.424 0 0-.518-.295-1.106-.295-.616 0-1.106.295-1.106.295.208-.251.622-.424 1.106-.424",
    style: {
      fill: "#414042",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.964 22.924-1.232.15.004 2.731 4.07 1.128.009-4.29-2.852.281",
    style: {
      fill: "#f5f5f5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m141.743 22.924 1.13.15.001 2.731-4.069 1.06.01-4.223 2.928.282",
    style: {
      fill: "#f9f9f9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.964 26.568h-1.232v-3.644h1.232v3.644m5.779 0h1.13v-3.644h-1.13v3.644",
    style: {
      fill: "#515067",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.815 22.642-1.385 1.893-1.12-1.645 1.166-.201 1.339-.047",
    style: {
      fill: "#c2c6c8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.815 22.642-1.444 1.567-1.062-1.319 1.74-.526.766.278",
    style: {
      fill: "#e6e6e6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.815 22.642 1.386 1.893 1.132-1.65-1.47-.243h-1.048",
    style: {
      fill: "#c2c6c8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.815 22.642 1.443 1.567 1.075-1.324-1.77-.521-.748.278",
    style: {
      fill: "#e6e6e6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.732 26.062v2.276a9.38 9.38 0 0 0 4.071.927 9.382 9.382 0 0 0 4.07-.927v-2.276h-8.14",
    style: {
      fill: "#2bb673",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.747 24.075a.041.041 0 0 1-.04-.042c0-.021.017-.041.04-.041.021-.002.04.018.04.041a.04.04 0 0 1-.04.042zm-.114-.042a.185.185 0 0 0 .18.186v-.374a.185.185 0 0 0-.18.188",
    style: {
      fill: "#55c58f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.891 23.99c.022 0 .04.02.04.042a.04.04 0 0 1-.04.041.04.04 0 0 1-.04-.04c0-.024.017-.043.04-.043zm-.078-.145v.374h.002l.001.001a.185.185 0 0 0 .18-.189.183.183 0 0 0-.181-.186h-.002",
    style: {
      fill: "#80d3ab",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.747 23.992c-.023 0-.04.02-.04.041 0 .023.018.042.04.042a.04.04 0 0 0 .04-.042c0-.023-.019-.043-.04-.041m.144.081a.04.04 0 0 0 .04-.04c0-.024-.018-.043-.04-.043-.023 0-.04.02-.04.043 0 .023.019.04.04.04",
    style: {
      fill: "#2bb673",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.745 25.184c-.023 0-.04-.02-.041-.041 0-.024.018-.043.04-.043.022 0 .04.02.04.04 0 .025-.017.044-.04.044zm-.115-.041c0 .102.082.185.181.186v-.375a.186.186 0 0 0-.18.189",
    style: {
      fill: "#55c58f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.89 25.1c.02 0 .04.019.04.04 0 .023-.02.043-.04.043-.022 0-.04-.02-.04-.042a.04.04 0 0 1 .04-.041zm-.079-.146v.375h.004c.1-.001.18-.084.18-.189a.183.183 0 0 0-.181-.186h-.002",
    style: {
      fill: "#80d3ab",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.745 25.1a.042.042 0 0 0-.041.043c.002.022.018.041.04.041.023 0 .04-.02.04-.043a.042.042 0 0 0-.04-.04m.146.082c.02 0 .04-.02.04-.043a.041.041 0 0 0-.04-.04.04.04 0 0 0-.04.04c0 .023.018.043.04.043",
    style: {
      fill: "#2bb673",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.098 12.482s-.605 2.15-3.817 2.33c0 0 .866-1.002.915-1.544 0 0-.925 1.333-2.832 1.475 0 0 .424-.825.496-1.475l-2.157 2.952s-1.68-5.727 3.5-6.054c2.77-.175 3.635.59 3.992 1.141.374.578-.097 1.175-.097 1.175",
    style: {
      fill: "#f14950",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.397 13.045s2.322 2.558 2.322 4.146c0 0 .726-3.968-.415-5.39-.36-.45-1.907-.858-1.907 1.244m-5.287 0s-2.324 2.558-2.324 4.146c0 0-.725-3.968.414-5.39.36-.45 1.91-.858 1.91 1.244",
    style: {
      fill: "#f14950",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.872 35.2h-8.14v-9.138h8.14v9.139",
    style: {
      fill: "#515067",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.383 13.18s-1.828-.712-3.262.389c0 0 .625.405 1.632.241 1.005-.162 1.63-.63 1.63-.63m12.842 0s1.83-.712 3.262.389c0 0-.625.405-1.63.241-1.007-.162-1.632-.63-1.632-.63",
    style: {
      fill: "#f46d73",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.625 49.768h1.743v-13.9h-1.743v13.9m-26.601 0h-1.742v-13.9h1.742v13.9",
    style: {
      fill: "#855c39",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.312 38.633h-28.41V34.6h28.41v4.033",
    style: {
      fill: "#855c39",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.368 36.617h-30.086v-2.89h30.086v2.89",
    style: {
      fill: "#9d7d61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.777 25.366c-.013.103-.027.233-.042.372l-.007-.006s-.55 4.452-.646 6.956c-.01.262 1.047.605 1.123.354.205-.68.504-2.715.71-4.217l.604-2.763.351-2.776c-1.986.182-2.003 1.32-2.094 2.08",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.75 22.924s-2.253.095-2.065 3.314c0 0 .813.434 1.688.434 0 0 .588-.459.63-.802 0 0 1.607-.982.364-2.584-.28-.362-.616-.362-.616-.362",
    style: {
      fill: "#515067",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.649 31.325h-8.622c-.62 0-1.124.502-1.124 1.123v.797c0 .622.503 1.124 1.124 1.124h8.622c.032 0 .06-.017.093-.02v-3.008c-.033-.002-.06-.016-.093-.016",
    style: {
      fill: "#2f1a0c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.742 31.79h-8.477c-.497 0-.9.353-.9.787v.555c0 .435.403.785.9.785h8.477V31.79",
    style: {
      fill: "#f9d2b5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.648 27.914h-8.621c-.62 0-1.125.506-1.125 1.125v.8c0 .617.504 1.122 1.125 1.122h8.621c.033 0 .06-.016.094-.018v-3.008c-.033-.002-.061-.02-.094-.02",
    style: {
      fill: "#ed1c24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.742 28.384h-8.477c-.498 0-.9.352-.9.787v.555c0 .435.402.783.9.783h8.477v-2.125",
    style: {
      fill: "#f9d2b5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.884 35.474h-8.585v-1.748h8.585v1.748",
    style: {
      fill: "#f9f9f9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.129 31.892s2.387.718 4.297 1.315c0 0 .802-.068 1.334.065.524.13 1.04.917.655.869-1.181-.146-1.716-.108-1.716-.108l-4.673-.307.103-1.834m12.723-6.526c.013.103.027.233.042.372l.007-.006s.55 4.452.646 6.956c.01.262-1.047.605-1.123.354-.205-.68-.504-2.715-.709-4.217l-.605-2.763-.351-2.776c1.987.182 2.004 1.32 2.094 2.08",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.879 22.924s2.253.095 2.065 3.314c0 0-.813.434-1.688.434 0 0-.588-.459-.63-.802 0 0-1.607-.982-.364-2.584.281-.362.617-.362.617-.362",
    style: {
      fill: "#515067",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.43 28.68a.532.532 0 0 0-.12-.745.533.533 0 0 0-.745.116l-.02.026.866.629.018-.026",
    style: {
      fill: "#f26522",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.411 28.706-.866-.629-.355.487.865.631.356-.489",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.055 29.195-.865-.63-3.208 4.405.865.63 3.208-4.405",
    style: {
      fill: "#ed1c24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m139.743 33.74.104-.14-.865-.63-.088.123-.326.96.378.275.797-.587",
    style: {
      fill: "#bcbec0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.946 34.328-.378-.275-.25.736z",
    style: {
      fill: "#808285",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.5 31.892s-2.386.718-4.297 1.315c0 0-.802-.068-1.334.065-.524.13-1.04.917-.655.869 1.181-.146 1.717-.108 1.717-.108l4.673-.307-.103-1.834",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-200.3 -18.937) scale(1.86739)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent8);
export default __webpack_public_path__ + "static/media/student8.f6e115b08fa9761e2373f411332c5080.svg";
export { ForwardRef as ReactComponent };